module.exports = "pegasus/assets/themelp1/small/home-bg.png";